import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export type StyledPatientGroupsProps = {
   direction?: 'row' | 'column';
};
export const StyledPatientGroups = styled(StyledFlex)<StyledPatientGroupsProps>`
   & > *:not(:first-child) {
      ${({ direction }) => (direction === 'column' ? 'margin-top: -4px;' : 'margin-left: -4px;')}
   }
`;

StyledPatientGroups.displayName = 'StyledPatientGroups';
